module.exports = __webpack_public_path__ + "static/product-l0950-79373f7feec7b33ec1520840a786196d.png";